import { createContext } from "react";
import { useFileTs } from "features/app/components/hooks/useFileTs";
import { EntityModelTimestampDto } from "../../../openapi";

interface InfoAppInitialState {
  fileTsList: EntityModelTimestampDto[];
  fileTsIsFetching: boolean;
  fileTsError: string;
  getFileTs: () => void;
  refetchFileTs: () => void;
}

const initialState: InfoAppInitialState = {
  fileTsList: [],
  fileTsIsFetching: false,
  fileTsError: "",
  getFileTs: () => {},
  refetchFileTs: () => {},
};

export const FileTsContext = createContext(initialState);

export const FileTsProvider: React.FC<any> = ({ children }) => {
  const {
    fileTsList,
    fileTsIsFetching,
    fileTsError,
    getFileTs,
    refetchFileTs,
  } = useFileTs();

  return (
    <FileTsContext.Provider
      value={{
        fileTsList,
        fileTsIsFetching,
        fileTsError,
        getFileTs,
        refetchFileTs,
      }}
    >
      {children}
    </FileTsContext.Provider>
  );
};
